import React from 'react';

import {pluralize} from 'BenchlingUtil';
import {Filter, FilterKey, keyToEmptyFilter, SearchContext, SortKey} from 'search/SearchConstants';
import ItemSearchInput, {Item} from 'ui-library/attach-dropdown/ItemSearchInput';
import {ChipSize} from 'ui-library/chips/Chip';
import {searchPost} from 'ui-library/inputs/ChipSearchInput';
import {typeToName} from 'util/NameUtil';
import {ElementKeyboardEvent} from 'util/Types';

import {ProcessOutputSummaryGraphQL} from '../../graphql-fragments/processes/__generated/ProcessOutputSummaryGraphQL';
import {ProcessSummaryGraphQL} from '../../graphql-fragments/processes/__generated/ProcessSummaryGraphQL';
import {ProcessTaskSummaryGraphQL} from '../../graphql-fragments/processes/__generated/ProcessTaskSummaryGraphQL';

export const SEARCH_URL = '/1/api/process-management:search';

type ProcessSummaryItem = ProcessSummaryGraphQL | ProcessOutputSummaryGraphQL | ProcessTaskSummaryGraphQL;

export interface ProcessManagementSearchInputProps {
  autoFocus?: boolean;
  chipSize?: ChipSize;
  className?: string;
  initialQuery?: string;
  selectedType: string;
  onBlur?: () => void;
  onChange: (item: Array<ProcessSummaryItem>) => void;
  onKeyDown?: (e: ElementKeyboardEvent) => void;
  selectedItems: Array<ProcessSummaryItem | Item>;
  tagSchemaId?: string | null;
  shouldAllowMultiple?: boolean;
  hideSelectedResults?: boolean;
  context?: SearchContext;
  disabled?: boolean;
  isReadOnly?: boolean;
  extraFilters?: Array<Filter>;
}

export default function ProcessManagementSearchInput(props: ProcessManagementSearchInputProps): JSX.Element {
  const filters = [
    ...(props.extraFilters ?? []),
    {...keyToEmptyFilter(FilterKey.TYPES), value: [props.selectedType]},
  ];

  const resultType = pluralize(2, typeToName(props.selectedType));

  return (
    <ItemSearchInput<ProcessSummaryItem | Item>
      autoFocus={props.autoFocus}
      chipSize={props.chipSize}
      className={props.className}
      doSearch={searchPost}
      fetchParams={{
        filters,
        offset: 0,
        sorts: [{key: SortKey.SORT_RELEVANCE_KEY, reverse: false}],
        context: props.context,
      }}
      initialQuery={props.initialQuery}
      itemKey="items"
      onBlur={props.onBlur}
      onChange={props.onChange}
      onKeyDown={props.onKeyDown}
      placeholder={`Search for ${resultType}`}
      searchURL={SEARCH_URL}
      selectedItems={props.selectedItems}
      shouldAllowMultiple={props.shouldAllowMultiple}
      hideSelectedResults={props.hideSelectedResults}
      disabled={props.disabled}
      isReadOnly={props.isReadOnly}
    />
  );
}

type ProcessManagementSearchInputWithItemsProps = {onChange: (newItems: Array<Item>) => void} & Omit<
  ProcessManagementSearchInputProps,
  'onChange'
>;

export function ProcessManagementSearchInputWithItems(
  props: ProcessManagementSearchInputWithItemsProps
): JSX.Element {
  return <ProcessManagementSearchInput {...props} />;
}
